<!-- @if (loginDisplay) { -->
<div class="mobile-header" *ngIf="!isFullScreenLayout">
    <button class="hamburger-btn" (click)="toggleMobileMenu()">
        <span class="material-icons">{{ isMobileMenuOpen ? 'close' : 'menu' }}</span>
    </button>
    <div class="mobile-logo">
        <!-- <img src="assets/images/logo.jpg" alt="Logo" style="height: 35px;" /> -->
        <h1 class="text-white font-bold text-2xl">LABTECH</h1>
    </div>
    <button class="mobile-logout-btn" (click)="logout()">
        <span class="material-icons">logout</span>
    </button>
</div>

<div class="mobile-overlay" *ngIf="!isFullScreenLayout && isMobileMenuOpen" (click)="toggleMobileMenu()"></div>

<div class="row no-margin">

    <div *ngIf="!isFullScreenLayout && !isToggle" class="col-md-2 overflow-hidden sidebar transition-all"
        [class.mobile-open]="isMobileMenuOpen">
        <div class="toggle-row desktop-only">
            <button class="icon-toggle-btn" (click)="toggleSidebar()" title="Collapse menu">
                <span class="material-icons">chevron_left</span>
            </button>
        </div>

        <div class="user-info text-center">
            <img *ngIf="userProfileImage" [src]="userProfileImage" alt="User Image" class="user-img" />
            <img *ngIf="!userProfileImage" src="assets/images/user.jpg" alt="User Image" class="user-img" />
            <div class="user-name">{{ userDisplayName }}</div>
        </div>

        <nav class="sidebar-nav">
            <a *ngFor="let menu of topLevelMenus; trackBy: trackByMenuKey" [routerLink]="[menu.route]"
                routerLinkActive="active" class="menu-item" (click)="closeMobileMenu()">
                <span class="material-icons">{{ menu.icon }}</span>
                <span>{{ menu.label }}</span>
            </a>

            <div *ngFor="let group of groupedMenus; trackBy: trackByGroupKey" class="menu-group">
                <input type="checkbox" [id]="'menu-' + group.key" class="toggle-menu" [checked]="isMenuOpen(group.key)" />
                <label [for]="'menu-' + group.key" class="menu-item" (click)="toggleMenu(group.key)">
                    <span class="material-icons">{{ group.icon }}</span>
                    <span>{{ group.label }}</span>
                    <span class="material-icons expand-more">expand_more</span>
                    <span class="material-icons expand-less">expand_less</span>
                </label>
                <ul class="submenu">
                    <li *ngFor="let menu of group.items; trackBy: trackByMenuKey">
                        <a [routerLink]="[menu.route]" routerLinkActive="active" (click)="closeMobileMenu()">
                            <span class="material-icons">{{ menu.icon }}</span>
                            {{ menu.label }}
                        </a>
                    </li>
                </ul>
            </div>
        </nav>

        <div class="logout-btn">
            <button class="btn-secondary w-100" (click)="logout();">
                <span class="material-icons">logout</span> Logout
            </button>
        </div>
    </div>

    <div *ngIf="!isFullScreenLayout && isToggle" class="col-md-1 sidebar1" [class.mobile-open]="isMobileMenuOpen">
        <div class="toggle-row desktop-only">
            <button class="icon-toggle-btn" (click)="toggleSidebar()" title="Expand menu">
                <span class="material-icons">chevron_right</span>
            </button>
        </div>

        <div class="user-info1 text-center">
            <img *ngIf="userProfileImage" [src]="userProfileImage" alt="User Image" class="user-img1"
                [title]="userDisplayName" />
            <img *ngIf="!userProfileImage" src="assets/images/user.jpg" alt="User Image" class="user-img1"
                [title]="userDisplayName" />
        </div>

        <nav class="sidebar-nav1 collapsed-menu">
            <a *ngFor="let menu of menuItems; trackBy: trackByMenuKey" [routerLink]="[menu.route]"
                routerLinkActive="active" class="menu-item1" [title]="menu.label" (click)="closeMobileMenu()">
                <span class="material-icons">{{ menu.icon }}</span>
            </a>
        </nav>

        <div class="logout-btn1">
            <button class="btn-secondary w-100" title="Logout" (click)="logout();">
                <span class="material-icons">logout</span>
            </button>
        </div>
    </div>

    <div class="content-column" [class.content-column--full-screen]="isFullScreenLayout">
        <div class="main-content" [class.sidebar-collapsed]="isToggle" [class.main-content--full-screen]="isFullScreenLayout">
            @if (!isIframe) {
            <router-outlet></router-outlet>
            }
        </div>
    </div>

</div>
